import { defineComponent as _defineComponent } from 'vue';
import { ref } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Panel',
    props: {
        title: { type: String, required: false },
        collapsable: { type: Boolean, required: false, default: false }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const isCollapsed = ref(false);
        const toggleCollapse = () => {
            if (props.collapsable) {
                isCollapsed.value = !isCollapsed.value;
            }
        };
        const __returned__ = { props, isCollapsed, toggleCollapse };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
